import Swal from 'sweetalert2'

// Swal.fire({
//     title: 'Error!',
//     text: 'Do you want to continue',
//     icon: 'error',
//     confirmButtonText: 'Cool'
// })

Swal.bindClickHandler();
